import { useMemo, useContext } from 'react';
import { TextureLoader, DoubleSide } from 'three';

import { GameContext } from '@/state/contexts';

const Card3D = ({ texturePath, viewCardModal, cardArr }) => {
	const scale = 1.1;
	const playerMatWidth = 2.5 * scale;
	const playerMatHeight = 3.5 * scale;

	const pc = useContext(GameContext);

	const texture = useMemo(
		() => new TextureLoader().load(texturePath),
		[cardArr]
	);

	if (!pc) return;

	return (
		<group>
			<mesh
				visible
				userData={{ hello: 'world' }}
				position={[0, 5, 15]}
				rotation={[0, 0, 0]}
				onClick={(e) => {
					e.stopPropagation();
					viewCardModal();
				}}
			>
				<boxGeometry args={[playerMatWidth, 0.1, playerMatHeight]} />
				<meshBasicMaterial
					attach="material"
					map={texture}
					side={DoubleSide}
				/>
			</mesh>
		</group>
	);
};

export default Card3D;
